<div
  #panel
  class="floating-panel"
  [class.minimized]="isMinimized"
  [class.maximized]="isMaximized"
  [class.ghost-mode]="isGhostMode"
  cdkDrag
  [cdkDragFreeDragPosition]="isMinimized ? minimizedDragPosition : dragPosition"
  (cdkDragEnded)="onDragEnded($event)"
  [cdkDragDisabled]="isMaximized"
  [style.min-width]="!isMinimized ? 'min(100dvw, 100vw, ' + minWidth + 'px)' : null"
  [style.min-height]="!isMinimized ? 'min(100dvh, 100vh, ' + minHeight + 'px)' : null"
  [style.max-width]="!isMaximized && !isMinimized ? 'min(100dvw, 100vw)' : null"
  [style.max-height]="!isMaximized && !isMinimized ? 'min(100dvh, 100vh)' : null"
  [style.outline]="config.whiteboardSharingEnabled ? '3px solid var(--greenb80)' : '3px solid var(--greyb80)'"
>
  <!-- Header sempre visibile -->
  <div class="panel-header" cdkDragHandle (dblclick)="onHeaderDoubleClick()">
    <div class="panel-title">
      <span 
        *ngIf="isMinimized" 
        class="material-symbols-outlined minimized-icon"
        [matTooltip]="title"
        matTooltipPosition="right"
      >{{ minimizedIcon }}</span>
      <span *ngIf="!isMinimized">{{ title }}</span>
    </div>
    <div class="panel-controls">
      <button
        *ngIf="showMinimize"
        mat-icon-button
        class="control-button"
        [class.restore-button]="isMinimized"
        (click)="toggleMinimize()"
        [attr.aria-label]="isMinimized ? 'Restore' : 'Minimize'"
      >
        <span class="material-symbols-outlined">{{ isMinimized ? 'open_in_full' : 'minimize' }}</span>
      </button>
      <button
        *ngIf="showMaximize && !isMinimized && !config.isMobilePhone"
        mat-icon-button
        class="control-button"
        (click)="toggleMaximize()"
        [attr.aria-label]="isMaximized ? 'Restore' : 'Maximize'"
      >
        <span class="material-symbols-outlined">{{ isMaximized ? 'close_fullscreen' : 'open_in_full' }}</span>
      </button>
      <button
        *ngIf="!isMinimized && !config.whiteboardReadonly"
        mat-icon-button
        class="control-button close-button"
        (click)="onClose()"
        aria-label="Close"
      >
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </div>

  <!-- Contenuto (nascosto quando minimizzato) -->
  <div class="panel-content" *ngIf="!isMinimized">
    <ng-content></ng-content>
  </div>
</div>
